export const GET_FAVORITES = 'GIFTYA/GET_FAVORITES';
export const GET_FAVORITES_RESET = 'GIFTYA/GET_FAVORITES_RESET';
export const POST_FAVORITE = 'GIFTYA/POST_FAVORITE';
export const POST_FAVORITE_RESET = 'GIFTYA/POST_FAVORITE_RESET';
export const POST_UNFAVORITE = 'GIFTYA/POST_UNFAVORITE';
export const POST_UNFAVORITE_RESET = 'GIFTYA/POST_UNFAVORITE_RESET';
export const UPDATE_FAVORITES = 'GIFTYA/UPDATE_FAVORITES';
export const SUBMIT_CREDIT_REQUEST_FORM = 'GIFTYA/SUBMIT_CREDIT_REQUEST_FORM';
export const SUBMIT_CREDIT_REQUEST_FORM_RESET = 'GIFTYA/SUBMIT_CREDIT_REQUEST_FORM_RESET';


export const submitCreditRequestForm = (payload, meta = {}, error = false) => ({
    type: SUBMIT_CREDIT_REQUEST_FORM,
    payload,
    meta,
    error
});
export const submitCreditRequestFormReset = (payload, meta, error) => ({
    type: SUBMIT_CREDIT_REQUEST_FORM_RESET,
    payload,
    meta,
    error
});
export const getFavorites = (payload, meta, error) => ({
    type: GET_FAVORITES,
    payload,
    meta,
    error
});
export const getFavoritesReset = (payload, meta, error) => ({
    type: GET_FAVORITES_RESET,
    payload,
    meta,
    error
});

export const postFavorite = (payload, meta, error) => ({
    type: POST_FAVORITE,
    payload,
    meta,
    error
});
export const postFavoriteReset = (payload, meta, error) => ({
    type: POST_FAVORITE_RESET,
    payload,
    meta,
    error
});

export const postUnfavorite = (payload, meta, error) => ({
    type: POST_UNFAVORITE,
    payload,
    meta,
    error
});
export const postUnfavoriteReset = (payload, meta, error) => ({
    type: POST_UNFAVORITE_RESET,
    payload,
    meta,
    error
});
export const updateFavorites = (payload, meta, error) => ({
    type: UPDATE_FAVORITES,
    payload,
    meta,
    error
});